<div class="premium-dialog" role="dialog" aria-labelledby="dialog-title" (click)="onDialogClick($event)">
  <!-- Inner content that prevents click propagation -->
  <div class="dialog-content-wrapper" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="dialog-header">
      <div class="warning-icon" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
        </svg>
      </div>
      <h2 id="dialog-title">Stock insuffisant</h2>
    </div>
    
    <!-- Content -->
    <div class="dialog-content">
      <div class="info-row">
        <div class="info-label">Produit</div>
        <div class="info-value" title="{{data.productName}}">{{data.productName}}</div>
      </div>
      
      <div class="info-row">
        <div class="info-label">Stock disponible</div>
        <div class="info-value">
          <span class="highlight">{{data.available}}</span>
        </div>
      </div>
      
      <div class="input-container">
        <label for="quantity">Quantité à ajouter</label>
        <div class="quantity-control" role="group" aria-labelledby="quantity-label">
          <button 
            type="button"
            class="quantity-btn" 
            (click)="decreaseQuantity()" 
            aria-label="Diminuer la quantité">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">
              <path d="M19 13H5v-2h14v2z"/>
            </svg>
          </button>
          <input 
            id="quantity"
            type="number" 
            class="quantity-input" 
            [(ngModel)]="data.newQuantity" 
            step="any"
            aria-label="Quantité"
          >
          <button 
            type="button"
            class="quantity-btn" 
            (click)="increaseQuantity()" 
            aria-label="Augmenter la quantité">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">
              <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>
            </svg>
          </button>
        </div>
        <div class="quantity-hint" aria-live="polite">
          Entrez n'importe quelle valeur
        </div>
      </div>
    </div>
    
    <!-- Actions -->
    <div class="dialog-actions">
      <button type="button" class="btn-cancel" (click)="onCancel()">Annuler</button>
      <button type="button" class="btn-confirm" (click)="onConfirm()">Valider</button>
    </div>
  </div>
</div>
